// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"10579c3a","609":"e8f15e63","773":"d2d3d871"}[chunkId] + ".chunk.js";
};